import { ImageName } from "@mcleod/images";
import { AbstractTableHeadingButton } from "../../AbstractTableHeadingButton";
import { ButtonVariant } from "../../../../button/ButtonVariant";
import { Component } from "../../../../../base/Component";
import { ReflectiveDialogs } from "../../../../../base/ReflectiveDialogs";
import { ReflectiveSnackbars } from "../../../../../base/ReflectiveSnackbars";
import { Table } from "../../../Table";
import { TableRow } from "../../../TableRow";

export class DeleteButton extends AbstractTableHeadingButton {
    override create() {
        super.create();
        this.button.setProps({
            enabledInTableHeader: (_component: Component, table: Table): boolean => {
                return table.selectedRowCount > 0 &&
                    table.selectedRows.every((row: TableRow) => row.allowDelete === true);
            },
            id: `${this.table.id}-tools-buttonDelete`,
            variant: ButtonVariant.round,
            imageName: ImageName.delete,
            onClick: () => this.handleDelete(),
            tooltip: "Delete the selected rows"
        });
    }

    private async handleDelete() {
        const sel = this.table.selectedRows;
        if (sel.length === 0) {
            ReflectiveDialogs.showMessage("No records are selected to delete.");
            return;
        }

        if (this.table.dataSource?.parentDataSource != null && !this.table.persistChangesImmediately) {
            // We want to cache the deletes in the DataSource.deletedData array. The parentDataSource will handle deleting the child data.
            for (let i = sel.length - 1; i >= 0; i--) {
                this.table.deleteRow(sel[i]);
            }
        } else if (await this.table.confirmRowDelete(sel)) {
            for (let i = sel.length - 1; i >= 0; i--) {
                if (this.table.persistChangesImmediately) {
                    await sel[i].data.delete();
                }
                this.table.deleteRow(sel[i]);
            }
            ReflectiveSnackbars.showSnackbar("Selected " + (sel.length === 1 ? "record has" : "records have") + " been deleted.");
        }
    }
}
